<template>
    <div class="scroll-container">
        <div style="color: #fff;">事件列表</div>
        <!-- 使用ref替代ID，更安全的获取方式 -->
        <div class="scroll-wrapper" ref="scrollWrapper">
            <ul 
                v-infinite-scroll="load" 
                infinite-scroll-disabled="loading"
                infinite-scroll-distance="10"
                infinite-scroll-container="this.$refs.scrollWrapper"
                style="padding: 0px;margin: 0px;"
                class="infinite-list"
                ref="infiniteList"
            >
                <li v-for="(item, index) in displayList" class="infinite-list-item" style="color: #fff;" :key="index">
                    <div style="border: 1px solid #1E524F;display: flex; flex-direction: column;">
                        <div style="display:flex;justify-content: space-between;align-items: center;background:rgba(18, 59, 55, 0.30);padding: 10px;">
                            <div style="display: flex;align-items: center;">
                                <img :src="$staticUrl('/statics/2025/09/17/process_20250917113822A089.png')" alt="" style="width: 18px;height: 18px;vertical-align: bottom;"></img>
                                <span style="margin-left: 5px;font-size: 15px;font-weight: bold;color: #FF3A3A;">{{ item.reportStatus === '4' ? '超时待处理' : '待处理' }}</span>
                            </div>
                            <div style="border: 1px solid rgba(14, 224, 212, 0.6);background:rgba(22, 93, 86, 0.6);font-size: 12px;color: #0EE0D4;width: 60px;height: 30px;border-radius: 8px;line-height: 30px;text-align: center;" @click="navDetail(item)">
                                详情
                            </div>
                        </div>
                        <div style="display: flex;padding: 10px;">
                            <div style="font-size: 15px;color: #fff;font-weight: bold;">
                                {{ item.communityName }}
                            </div>
                            <div style="font-size: 15px;color: #fff;margin-left: 10px;">
                                --{{ item.estateName }}
                            </div>
                        </div>
                        <div style="display: flex;padding: 10px; margin-top: 30px;">
                            <div style="font-size: 13px;color: #fff;">
                               所在位置：{{ item.reportAddress }}
                            </div>
                            <div style="font-size: 13px;color: #fff; margin-left: 50px;">
                               提交时间：{{ item.createTime }}
                            </div>
                            <div style="font-size: 13px;color: #fff; margin-left: 50px;" v-if="item.reportType === '0'">
                               事件类型：业主报修
                            </div>
                            <div style="font-size: 13px;color: #fff; margin-left: 50px;" v-if="item.reportType === '1'">
                               事件类型：保洁
                            </div>
                            <div style="font-size: 13px;color: #fff; margin-left: 50px;" v-if="item.reportType === '2'">
                               事件类型：工程维修
                            </div>
                            <div style="font-size: 13px;color: #fff; margin-left: 50px;" v-if="item.reportType === '3'">
                               事件类型：投诉建议
                            </div>
                            <div style="font-size: 13px;color: #fff; margin-left: 50px;" v-if="item.reportType === '4'">
                               事件类型：其他
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        list: { type: Array, default: () => [] }
    },
    data() {
        return {
            displayList: [...this.list],
            loading: false,
            
        }
    },
    mounted() {
        
        // 确保DOM完全渲染后再执行
        this.$nextTick(() => {
            // 安全检查：先确认元素存在
            if (this.$refs.scrollWrapper && this.$refs.infiniteList) {
                // 绑定滚动事件
                this.$refs.scrollWrapper.addEventListener('scroll', this.handleManualScroll);
                // 检查初始内容
                this.ensureEnoughContent();
            } else if (!this._isDestroyed) {
                // 重试机制：100ms后再次尝试
                setTimeout(() => {
                  if (!this._isDestroyed) this.mounted();
                }, 100);
            }
        });
    },
    beforeDestroy() {
        // 移除事件前先检查元素是否存在
        if (this.$refs.scrollWrapper) {
            this.$refs.scrollWrapper.removeEventListener('scroll', this.handleManualScroll);
        }
    },
    methods: {
        navDetail(item) {
            window.open(`/to_do-info?id=${item.id}`, '_self')
        },
        ensureEnoughContent() {
            // 双重安全检查
            if (!this.$refs.scrollWrapper || !this.$refs.infiniteList) return;
            
            const container = this.$refs.scrollWrapper;
            const list = this.$refs.infiniteList;
            
            // 确保容器和列表的高度都有效
            if (container.clientHeight && list.clientHeight && list.clientHeight <= container.clientHeight) {
                // this.load();
            }
        },
        load() {
            // console.log('加载中...');
            if (this.loading) return;
            
            this.loading = true;
            
            this.$emit('load');
        },
        handleManualScroll() {
            if (!this.$refs.scrollWrapper) return;
            
            const container = this.$refs.scrollWrapper;
            const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
            // console.log('scrollBottom', scrollBottom == 0);
            if (scrollBottom == 0) {
                this.load();
            }
        }
    }
}
</script>
<style scoped>
/* 样式保持不变 */
.scroll-container {
    padding: 20px;
    width: 1500px;
    height: 700px;
    background: rgba(0,0,0,0.7);
}

.scroll-wrapper {
    width: 1500px;
    height: 660px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
}

.infinite-list-item {
    margin-top: 15px;
    margin-right: 10px;
}
</style>
    